import { Criteria } from '@api';

export function formatCriteriaString(criteriaArray: Criteria[]): string {
  return criteriaArray
    .map((criteria) => `${criteria.field}${criteria.operator}${criteria.value}`)
    .join(',');
}
